<template>
  <div>
    <div class="flex flex-wrap items-center">
      <div class="w-1/3 flex">
        <!-- invoice customer -->
        <div class="max-w-xs w-full">
          <select-2
            autocomplete
            id="payment_type"
            :value="customer"
            @search="handleCustomerSearch"
            @input="(item) => $emit('customerChangeHandler', item)"
            placeholder="Please Select Customer"
            newLabel="Add New Customer"
            @addNew="toggleCreateNewCustomer"
            @scrollEnd="getCustomers(page + 1)"
            :ssr="true"
            :loading="customer_loading"
            :options="customerOptions"
          />
        </div>
      </div>
    </div>
    <!-- Popup Model - for create customer -->
    <create-customer v-if="is_popup_active_create_customerModalMounted" :is_popup_active_create_customer.sync="is_popup_active_create_customer" @updateCustomerList="updateCustomerList" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import CreateCustomer from '@/views/pos/components/POS/CreateCustomerPopup.vue'

export default {
  name: 'PosHeader',

  components: {
    Select2,
    CreateCustomer
  },

  props: {
    customer: Number,
    customerDetail: Object,
    viewRendered: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      is_popup_active_create_customer: false,
      is_popup_active_create_customerModalMounted: false,
      activeCustomerPurcehaseModel: false,
      isAddTransporterModalShow: false,
      customerOptions: [],
      page: 1,
      limit: 10,
      filteredCount: 0,
      search: null,
      customer_loading: false
    }
  },

  methods: {
    ...mapActions('pos', {
      fetchCustomers: 'get_customers'
    }),

    // handle customer search
    async handleCustomerSearch(val) {
      this.search = val
      this.customerOptions = []
      await this.getCustomers(1)
    },

    // Get Customers
    async getCustomers(page = this.page) {
      try {
        if (!this.viewRendered) return false
        if (this.customerOptions.length && this.customerOptions.length === this.filteredCount) return false

        this.customer_loading = true

        const payload = {
          search: this.search,
          limit: 0,
          page: 1,
          customer: this.customer
        }

        this.page = page

        const res = await this.fetchCustomers(payload)
        this.filteredCount = res.FilteredCount
        const data = res.data.reduce((acc, item) => {
          item.label = item.business_name ? item.business_name : `${item.first_name} ${item.last_name}`
          item.value = item.id
          acc.push(item)
          return acc
        }, [])

        this.customerOptions = [...this.customerOptions, ...data]

        if (localStorage.getItem('posCustomerId')) {
          const previousCustomer = this.customerOptions.find((x) => x.value === Number(localStorage.getItem('posCustomerId')))
          if (previousCustomer && previousCustomer.id !== this.customer) {
            this.$emit('customerChangeHandler', previousCustomer)
          }
        }
        if (this.$route.params.id) {
          this.$parent.handleClientPatientDetail()
        }
        this.customer_loading = false
        return this.customerOptions
      } catch ({ message }) {
        this.customer_loading = false
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    updateCustomerList() {
      this.customerOptions = []
      this.getCustomers()
    },
    // add cutomer modal
    toggleCreateNewCustomer() {
      this.is_popup_active_create_customer = true
      this.is_popup_active_create_customerModalMounted = true
    }
  },
  watch: {
    viewRendered: {
      immediate: true,
      handler() {
        this.getCustomers()
      }
    },

    is_popup_active_create_customer: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.is_popup_active_create_customerModalMounted = false
          }, 0)
        }
      }
    }
  },
  beforeRouteLeave(_, __, next) {
    this.is_popup_active_create_customer = false
    next()
  }
}
</script>